import { BankLink } from '@orbis-systems/orbis-api-middleware';
import { flatMap, isArray } from 'lodash';

export function normalizeBankLinksResponse(data: unknown): BankLink[] {
    if (isArray(data)) {
        if (data.length > 0 && isArray(data[0])) {
            return flatMap(data, (links) => links);
        }

        return data;
    }

    if (data && typeof data === 'object') {
        return flatMap(Object.entries(data as Record<string, BankLink[]>), ([accountNumber, links]) =>
            links.map((link) => (link.account ? link : { ...link, account: accountNumber })),
        );
    }

    throw new Error('Feature not supported');
}
